import { hPost } from '@mcfe/tools';

export const API = {
    VSS_PRINT_BEFORE_DATA: '/api/m/print/label/before/queryV2',
    // 查询打印标签信息
    VSS_PRINT_DATA: '/api/m/print/vss/prePurchase',
    // 查询预采计划列表
    PLAN_DETAIL_LIST: '/api/scm/shepherd/pps/queryPrePurchasePlanDetailList',
    // 导出预采计划列表
    EXPORT_PLAN_DETAIL_LIST: '/api/scm/shepherd/pps/exportPrePurchasePlanDetailList',
    // 校验并查询商品产地信息
    CHECK_AND_QUERY_PRODUCT_ORIGIN: '/api/m/print/vss/query/origin/place',
};

export const exportPlanDetailList = (params, options) => hPost(API.EXPORT_PLAN_DETAIL_LIST, params, options);
export const getVssPrintBeforeData = (params, options) => hPost(API.VSS_PRINT_BEFORE_DATA, params, options);
export const getVssPrintData = (params, options) => hPost(API.VSS_PRINT_DATA, params, options);
export const checkAndQueryProductOrigin = (params, options) => hPost(API.CHECK_AND_QUERY_PRODUCT_ORIGIN, params, options);
